import {
  Home,
  Login,
  Profile,
  Challenges,
  MyProducts,
  PDFView,
  Cardio,
  ChangePassword,
  DespuesTest,
  AfterVerification,
  PasswordRecovery,
  TuProgreso,
  MisRutinas,
  RutinasPorDía,
  PlanAlimentacion,
  Podcasts,
  PreguntasFrecuentes,
  ProductDetail,
  Aceleradores,
  UploadVideo,
} from '../Pages/Pages';

import IRoute from '../Interfaces/IRoute';

const routes: IRoute[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/perfil',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/retos',
    name: 'Challenges',
    component: Challenges,
  },
  {
    path: '/mis-productos',
    name: 'MyProducts',
    component: MyProducts,
  },
  {
    path: '/producto/:id',
    name: 'Product',
    component: ProductDetail,
  },
  {
    path: '/pdf',
    name: 'PDFPage',
    component: PDFView,
  },
  {
    path: '/changepassword',
    name: 'changePassword',
    component: ChangePassword,
  },
  {
    path: '/misRutinas',
    name: 'misRutinas',
    component: MisRutinas,
  },
  {
    path: '/ejercicioRutina',
    name: 'ejercicioRutina',
    component: RutinasPorDía,
  },
  {
    path: '/podcasts',
    name: 'podcasts',
    component: Podcasts,
  },
  {
    path: '/cardioRutinas',
    name: 'cardios',
    component: Cardio,
  },
  {
    path: '/despuesTest',
    name: 'despuesTest',
    component: DespuesTest,
  },
  {
    path: '/recuperarContrasena',
    name: 'recuperarContrasena',
    component: PasswordRecovery,
  },
  {
    path: '/resetearContrasena',
    name: 'resetearContrasena',
    component: AfterVerification,
  },
  {
    path: '/tuProgreso',
    name: 'tuProgreso',
    component: TuProgreso,
  },
  {
    path: '/preguntasFrecuentes',
    name: 'preguntasFrecuentes',
    component: PreguntasFrecuentes,
  },
  {
    path: '/planAlimentacion',
    name: 'planAlimentacion',
    component: PlanAlimentacion,
  },
  {
    path: '/aceleradores',
    name: 'aceleradores',
    component: Aceleradores,
  },
  {
    path: '/uploadVideo',
    name: 'uploadVideo',
    component: UploadVideo,
  }
];

export default routes;
